// extracted by mini-css-extract-plugin
export default {"input":"InputSection_input__zCvck","invalid":"InputSection_invalid__gWKgK","btn":"InputSection_btn__bPzdV","url-icon":"InputSection_url-icon__Kgw64"};